<template>
  <div>
    <div class="head">
      <el-button type="primary" size="small" style="width: 200px" @click="addBtn">新增</el-button>
    </div>
    <div class="content">
      <el-table
          :data="tbWorkPermitInfoList"
          :header-cell-style="{ background: 'rgb(250,250,250)' }"
          style="width: 100%">
        <el-table-column label="企业编码" align="center" prop="companyCode"/>
        <el-table-column label="签发时间" align="center" type="datetime" prop="issueTime">
          <template slot-scope="{ row }">
            <span v-if="row.issueTime">{{ row.issueTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="作业验收时间" align="center" type="datetime" prop="acceptanceTime" width="180">
          <template slot-scope="{ row }">
            <span v-if="row.acceptanceTime">{{ row.acceptanceTime | timeFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="作业是否变更" align="center" prop="isChanged">
          <template slot-scope="{ row }">
            <Tag v-if="row.isChanged===1">是</Tag>
            <Tag v-if="row.isChanged===0">否</Tag>
          </template>
        </el-table-column>
        <el-table-column label="变更原因" align="center" prop="changedCause"/>
        <el-table-column label="作业是否取消" align="center" prop="isCancelled">
          <template slot-scope="{ row }">
            <Tag v-if="row.isCancelled===1">是</Tag>
            <Tag v-if="row.isCancelled===0">否</Tag>
          </template>
        </el-table-column>
        <el-table-column label="取消原因" align="center" prop="cancelledCause"/>
        <el-table-column label="状态" align="center" prop="isUpload">
          <template slot-scope="{ row }">
            <Tag v-if="row.isUpload===1" color="success">已上报</Tag>
            <Tag v-if="row.isUpload===0" color="warning">未上报</Tag>
          </template>
        </el-table-column>
        <!--        <el-table-column
                    label="负责人"
                    align="center">
                  <template slot-scope="{ row }">
                    {{ getEmployeeName(row.employeeId) }}
                  </template>
                </el-table-column>-->
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
            <span style="margin: 0 5px;color: #e8e8e8">|</span>
            <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
      </div>
    </div>

    <!-- 添加或修改对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="特殊作业活动信息" prop="activityId">
          <el-select v-model="form.activityId" placeholder="请选择特殊作业活动信息">
            <el-option
                v-for="dict in tbWorkPermitDataList"
                :key="dict.id"
                :label="dict.jobContent"
                :value="dict.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签发时间" prop="issueTime">
          <el-date-picker
              v-model="form.issueTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 50%;"
              placeholder="请选择签发时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="作业验收时间" prop="acceptanceTime">

          <el-date-picker
                          v-model="form.acceptanceTime"
                          type="datetime"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="请选择作业验收时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="作业是否变更" prop="isChanged">
          <el-select v-model="form.isChanged" style="width: 100%">
            <el-option :value="1" label="是"/>
            <el-option :value="0" label="否"/>
          </el-select>
        </el-form-item>
        <el-form-item label="变更原因" prop="changedCause">
          <el-input v-model="form.changedCause" placeholder="请输入变更原因"/>
        </el-form-item>
        <el-form-item label="作业是否取消" prop="isCancelled">
          <el-select v-model="form.isCancelled" style="width: 100%">
            <el-option :value="1" label="是"/>
            <el-option :value="0" label="否"/>
          </el-select>
        </el-form-item>
        <el-form-item label="取消原因" prop="cancelledCause">
          <el-input v-model="form.cancelledCause" placeholder="请输入取消原因"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import {
  listTbWorkPermitInfo,
  getTbWorkPermitInfo,
  addTbWorkPermitInfo,
  updateTbWorkPermitInfo,
  delTbWorkPermitInfo
} from '@/api/baseDate/TbWorkPermitInfo';
import {listTbWorkPermitData} from '@/api/baseDate/TbWorkPermitData';

export default {
  name: "TbWorkPermitInfo",
  data() {
    return {
      tbWorkPermitInfoList: [],
      tbWorkPermitDataList: [],
      total: 0,
      curPage: 1,
      pageSize: 10,
      open: false,
      form: {},
      rules: {},
      title: null,
    }
  },
  created() {
    this.getTbWorkPermitInfoList();
    this.getTbWorkPermitDataList();
  },
  methods: {
    getTbWorkPermitInfoList() {
      listTbWorkPermitInfo({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
        this.tbWorkPermitInfoList = res.body.data
        this.total = res.body.cum
      })
    },
    getTbWorkPermitDataList() {
      listTbWorkPermitData().then(res => {
        this.tbWorkPermitDataList = res.body.data
      })
    },
    handleType(type) {
      let list = this.riskLevelArr.filter(item => item.value === type)
      return list[0].label
    },
    pageChange(val) {
      this.curPage = val;
      this.getTbWorkPermitInfoList();
    },
    addBtn() {
      this.reset()
      this.open = true
      this.title = '添加宝山园区特殊作业活动证信息'

    },
    editBtn(row) {
      this.reset()
      const id = row.id
      getTbWorkPermitInfo(id).then(response => {
        this.form = response.body.data
        this.open = true
        this.title = '修改宝山园区特殊作业活动证信息'
      })
    },
    deleteBtn(row) {
      delTbWorkPermitInfo(row.id).then(res => {
        this.$message.success('删除成功')
        this.getTbWorkPermitInfoList()
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        issueTime: null,
        acceptanceTime: null,
        isChanged: null,
        changedCause: null,
        activityId: null,
        isCancelled: null,
        cancelledCause: null,
        isUpload: null
      }
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateTbWorkPermitInfo(this.form).then(response => {
              this.open = false
              this.$message.success('修改成功')
              this.getTbWorkPermitInfoList()
            })
          } else {
            addTbWorkPermitInfo(this.form).then(response => {
              this.open = false
              this.$message.success('新增成功')
              this.getTbWorkPermitInfoList()
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  width: calc(100% - 280px);
}

.btn {
  cursor: pointer;
}
</style>
